import React, { useEffect } from "react";
import { Hit } from "../Hit/Hit";
import { useInstantSearch } from "react-instantsearch";

export const Results: React.FC<any> = ({
  isQuickJobs,
  noHitsText,
  children,
  setNumber,
  hits,
  visibleHits,
  ...props
}) => {
  const { results: searchResults } = useInstantSearch();

  useEffect(() => {
    if (searchResults && setNumber) {
      setNumber(searchResults.nbHits);
    }
  }, [searchResults, setNumber]);

  if (isQuickJobs) {
    return searchResults && searchResults?.nbHits !== 0 ? (
      <div className="ais-Hits">
        <ul className="ais-Hits-list">
          {searchResults.hits.map((hit: any, index: number) => (
            <li key={`${hit.objectID}-${index}`} className="ais-Hits-item">
              <Hit hit={hit} />
            </li>
          ))}
        </ul>
      </div>
    ) : null;
  }

  return searchResults && searchResults?.nbHits !== 0 ? children : null;
};
